var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReady({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.45801 14.5C1.45801 7.57329 7.07293 1.95837 13.9997 1.95837C20.9264 1.95837 26.5413 7.57329 26.5413 14.5C26.5413 21.4268 20.9264 27.0417 13.9997 27.0417C7.07293 27.0417 1.45801 21.4268 1.45801 14.5Z",
    fill: "#22C55E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4514 9.79779C20.7931 10.1395 20.7931 10.6935 20.4514 11.0352L12.2847 19.2019C11.943 19.5436 11.389 19.5436 11.0473 19.2019L7.5473 15.7019C7.20559 15.3602 7.20559 14.8062 7.5473 14.4645C7.88901 14.1227 8.44303 14.1227 8.78473 14.4645L11.666 17.3457L19.214 9.79779C19.5557 9.45608 20.1097 9.45608 20.4514 9.79779Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReady);
export default __webpack_public_path__ + "static/media/READY.50f7d991ed08a74819d8dce859596052.svg";
export { ForwardRef as ReactComponent };